export enum CacheTag {
  QUOTE = 'Quote',
  USER = 'User',
}
